import $ from "jquery";

const COOKIE_CONSENT_AGREE_BUTTON = document.getElementById(
  "cookie-consent-agree",
);

COOKIE_CONSENT_AGREE_BUTTON?.addEventListener("click", () => {
  $.ajax({
    url: "/cookies/consent",
    type: "POST",
    data: { cookie_consent: "true" },
  });
});
